import React, {
  Fragment, FunctionComponent, useEffect
} from "react";
import "./confirm.scss";
import { EMAIL_LOGOUT_GA, EMAIL_PAGELOAD_PARAM, EMAIL_PAGELOAD_VPV, pushDataLayer } from '../../constants/gaConstants';
import AxisButton from "../../components/button/button";
import Text from "../../components/typography/typgraphy";
import Card from "../../components/cards/card";
import locationOff from "../../assets/images/locationOff.svg";
import { getTransactionIdFromURL, logoutUser } from "../../constants/utils";
import { ProfileDetailsState, initialState as emptyTransactionState } from "../../core/reducers/profileDetailsReducer";
import Loader from "../../components/loader/loader";
import { TransactionState } from "../../core/reducers/transactionDetailsReducer";
import { AuthState } from "../../core/reducers/authReducer";

interface IConfirmProps {
  profileDetails: ProfileDetailsState;
  isAuthenticated: boolean;
  resumeJourneyResponse: boolean;
  isLoading: boolean;
  getProfileDetails: () => void;
  resumeJourney: () => void;
  transactionDetails: TransactionState;
  partnerData: AuthState;
}

const Confirm: FunctionComponent<IConfirmProps> = (props) => {
  const { profileDetails, isAuthenticated, resumeJourneyResponse, isLoading, getProfileDetails, resumeJourney, transactionDetails, partnerData } = props

  const txnId = getTransactionIdFromURL();

  useEffect(() => {
    pushDataLayer(EMAIL_PAGELOAD_VPV(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    pushDataLayer(EMAIL_PAGELOAD_PARAM(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
  }, [])

  useEffect(() => {
    if (isAuthenticated && (profileDetails !== emptyTransactionState) && !resumeJourneyResponse) {
      resumeJourney()
    }
  }, [isAuthenticated, profileDetails, resumeJourney, resumeJourneyResponse])
  useEffect(() => {
    if (isAuthenticated && (profileDetails === emptyTransactionState)) {
      getProfileDetails();
    }
  }, [isAuthenticated, resumeJourneyResponse, profileDetails, resumeJourney, getProfileDetails])

  const handleLogout = () => {
    pushDataLayer(EMAIL_LOGOUT_GA(partnerData.customerId, transactionDetails.submitRequest.finalRemittanceAmt, txnId, transactionDetails.purposeCode, transactionDetails.submitRequest.funds.source))
    logoutUser()
  };

  return (
    <Fragment>
      {isLoading && <Loader />}
      <div className="container">
        <div className="ui-container">
          <Card>
            <div className="continue-card">
              <div className="header">
                <img
                  className="header-image"
                  src={locationOff}
                  alt="email-sent"
                ></img>

                <div className="continue-heading">
                  <Text fontWeight={1000} textAlign="center">
                    Check your Email
                  </Text>
                </div>
              </div>
              <Text className="email-text" textAlign="center" fontWeight={400}>
                We have shared an email on your email address&nbsp;
                <span className="heavy">
                  {profileDetails.emailId}
                </span>.
              </Text>

              <Text textAlign="center" className="continue-text">
                Kindly arrange for your bank statement for a period of 12 months
                and resume the remittance journey from where you left.
              </Text>

              <Text textAlign="center" className="confirm-text">
                Your continue journey link will be valid for a period of 24
                hours only
              </Text>
            </div>
          </Card>
        </div>
        <div className="proceed-container">
          <AxisButton
            onClick={handleLogout}
            customStyle={"submit-btn-primary"}
            variant="contained"
          >
            <Text className={"submit-btn-text"}>Logout</Text>
          </AxisButton>
        </div>
      </div>
    </Fragment>
  );

};

export default Confirm;
